import Typography from '@mui/material/Typography';
import { type LucideIcon } from 'lucide-react';
import { GradientText, InfoCardRow, InfoNameStack, InfoStack } from './style';

/** InfoCardProps with component fields */
interface InfoCardProps {
  icon: LucideIcon;
  color: string;
  title: string;
  value: string | number;
  unit?: string;
}

/**
 * InfoCard component displays latency information card with an icon, title, and value.
 * @param param0 - Props for the InfoCard component.
 * @returns JSX.Element with InfoCard structure
 */
function InfoCard({
  icon: Icon,
  color,
  title,
  value,
  unit = 'ms',
}: InfoCardProps) {
  return (
    <InfoCardRow>
      {/* InfoCard icon and title */}
      <InfoNameStack>
        <Icon size={16} color={color ? color : '#9E9E9E'} />
        <Typography variant="caption">{title}</Typography>
      </InfoNameStack>

      {/* InfoCard value and ms (latency unit) */}
      <InfoStack>
        <GradientText variant="h2" color={color}>
          {value ? value : '0'}
        </GradientText>
        {unit && <Typography variant="caption">{unit}</Typography>}
      </InfoStack>
    </InfoCardRow>
  );
}

export default InfoCard;
